import React, { PropsWithChildren } from 'react'
import { StyleSheet, View, Text, TouchableOpacity, Image } from 'react-native'
import { globalStyle } from '../../../theme/global'
import { useTranslation } from 'react-i18next'
import { corporateColor, white } from '../../../theme/colors'

interface Props extends PropsWithChildren {
  title: string
  onPress: () => void
}

export const Cards = ({ onPress, title, children }: Props) => {
  const { t: translation } = useTranslation()
  return (
    <TouchableOpacity activeOpacity={0.9} onPress={onPress} style={styles.container}>
      {children}
      <Text style={styles.title}>{translation(title)}</Text>
    </TouchableOpacity>
  )
}
const styles = StyleSheet.create({
  container: {
    borderRadius: 10,
    marginBottom: 20,
    padding: 34,
    backgroundColor: white,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 24,
    marginHorizontal: 24,
  },

  title: {
    fontSize: 18,
    fontWeight: '500',
    color: corporateColor,
    width: 135,
  },
})
